import el from "@cypherpotato/el";
import { Icon } from "./icon";
import { Table, TableActionCell, TableBody, TableCell, TableRow, TableSeparator } from "./table";
import { MutedText } from "./text";
import { Button } from "./button";

export function DataPickerControl({ data, value, allowNone = false, onSelect = null, onRemove = null, type = 'list' }) {

    const selectedValue = el.state.create(value);

    return el.state.listening([selectedValue], () =>
        Table(
            {
                $properties: {
                    value: {
                        get() {
                            return selectedValue.value;
                        },
                        set(value) {
                            selectedValue.value = value;
                        }
                    }
                },
                classList: [type !== 'grid' && "selectable", "border"]
            },
            TableBody(
                allowNone && TableRow(
                    TableCell(
                        el("div",
                            MutedText("(None)"),
                            el("span.highlighted-only.selected-icon",
                                Icon("check-line")
                            ),
                        )
                    ),
                    {
                        onClick() {
                            selectedValue.value = null;
                            onSelect && onSelect(null);
                        },
                        classList: [selectedValue.value === null && "highlighted"]
                    }
                ),
                type === 'grid' && TableRow(
                    TableCell(
                        el("div.data-picker-grid",
                            data.map(dataItem =>
                                dataItem.separator && el("div.data-picker-grid-separator", dataItem.separator) ||
                                el("div.data-picker-grid-item",
                                    dataItem.text,
                                    el("span.highlighted-only.selected-icon",
                                        Icon("check-line")
                                    ),
                                    {
                                        async onClick() {
                                            selectedValue.value = dataItem.value;
                                            onSelect && await onSelect(dataItem.value);
                                        },
                                        classList: [selectedValue.value === dataItem.value && "highlighted"]
                                    }
                                )
                            )
                        )
                    )
                ),
                type === 'list' && data.map(dataItem =>
                    dataItem.separator && TableSeparator(dataItem.separator) ||
                    TableRow(
                        TableCell(
                            el("div",
                                dataItem.text,
                                el("span.highlighted-only.selected-icon",
                                    Icon("check-line")
                                ),
                            ),
                            {
                                async onClick() {
                                    selectedValue.value = dataItem.value;
                                    onSelect && await onSelect(dataItem.value);
                                }
                            }
                        ),
                        onRemove && TableActionCell(
                            Button(Icon("delete-bin-7-line"), {
                                async onClick() {
                                    if (await onRemove(dataItem)) {
                                        this.closest("tr").remove();
                                    }
                                }
                            })
                        ),
                        {
                            classList: [selectedValue.value === dataItem.value && "highlighted"]
                        }
                    )
                )
            )
        )
    );
}

export function MultiDataPickerControl({ data, type = 'list', value = [] }) {
    const selectedValues = el.state.create(value);

    return el.state.listening([selectedValues], () =>
        Table(
            {
                $properties: {
                    value: {
                        get() {
                            return selectedValues.value;
                        },
                        set(newValue) {
                            selectedValues.value = Array.isArray(newValue) ? newValue : [newValue];
                        }
                    }
                },
                classList: [type !== 'grid' && "selectable", "border"]
            },
            type === 'grid' && TableBody(
                TableRow(
                    TableCell(
                        el("div.data-picker-grid",
                            data.map(dataItem =>
                                dataItem.separator && el("div.data-picker-grid-separator", dataItem.separator) ||
                                el("div.data-picker-grid-item",
                                    dataItem.text,
                                    el("span.highlighted-only.selected-icon",
                                        Icon("check-line")
                                    ),
                                    {
                                        onClick() {
                                            const currentValues = selectedValues.value;
                                            if (currentValues.includes(dataItem.value)) {
                                                selectedValues.value = currentValues.filter(v => v !== dataItem.value);
                                            } else {
                                                selectedValues.value = [...currentValues, dataItem.value];
                                            }
                                        },
                                        classList: [selectedValues.value.includes(dataItem.value) && "highlighted"]
                                    }
                                )
                            )
                        )
                    )
                )
            ),
            type === 'list' && TableBody(
                data.map(dataItem =>
                    dataItem.separator && TableSeparator(dataItem.separator) ||
                    TableRow(
                        TableCell(
                            el("div",
                                dataItem.text,
                                el("span.highlighted-only.selected-icon",
                                    Icon("check-line")
                                ),
                                {
                                    style: {
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        paddingRight: "10px"
                                    }
                                }
                            ),
                        ),
                        {
                            onClick() {
                                const currentValues = selectedValues.value;
                                if (currentValues.includes(dataItem.value)) {
                                    selectedValues.value = currentValues.filter(v => v !== dataItem.value);
                                } else {
                                    selectedValues.value = [...currentValues, dataItem.value];
                                }
                            },
                            classList: [selectedValues.value.includes(dataItem.value) && "highlighted"]
                        }
                    )
                )
            )
        )
    );
}